/* Encabezado página principal del proyecto, incluye menu, perfil del usuario y notificaciones */

//*react- recursos
  import { useState, useEffect } from "react";
  import { useHistory } from "react-router";
  import shallow from "zustand/shallow";

//*componentes-utiles
  import CargandoSpin from "../../../componentes/CargandoSpin";
  import { SlidingPanel } from "@reactjscomponentrepository/frontend-components/lib/components";

//*clases
  import Navbar from "react-bootstrap/Navbar";
  import Nav from "react-bootstrap/Nav";
  import Button1 from "@mui/material/Button";
 /*  import "../splidingPanel.css" */

  //iconos
  import { FaUserCircle } from "react-icons/fa";
  import { ImExit } from "react-icons/im";
  import { FaBell } from "react-icons/fa";

//*datos
  import etiquetasSSC from "../../../datos/json/etiquetasSSC.json";

//*imágenes
  import LogoProyecto from "../../../imagenes/proyecto/INEGI_SSC_logo.png";
  import LineaT from "../../../imagenes/lineaTraining.png";

//*archivo & componentes (otros componentes enlazados)
  import GeneraMenu from "../../../componentes/generaMenu/GeneraMenuSSC";
  import Perfil from "./PerfilUsuario";
  import Notificaciones from "./Notificaciones";

//*api's (servicios y store)
  import authenticateStore from "../../../api/recursos/authenticate/authenticate.store";

//*store's
  import menuStore from "../../../stores/menu.store";

//*interfaces
  interface propsEncabezado {
    tokenStore: any;
    notTotalStore: any;
    recargaPaginaSSC_Not: any;
  }

//*componente 
  export default function Encabezado(props: propsEncabezado) {
    var _ = require("underscore");

    //*api store
      const { usuarioStore, rolsStore } = 
        authenticateStore((state: any) => ({
            usuarioStore: state.usuarioStore,
            rolsStore: state.rolsStore,
      }), shallow );

    //stores adicionales
      const { generaMenuxRolStore,  } = 
       menuStore((state: any) => ({
           generaMenuxRolStore: state.generaMenuxRolStore,
      }));

    //*variables y constantes de uso
      const APP_ENV = process.env.REACT_APP_ENV;

      let history = useHistory();

      let eti_Eti = etiquetasSSC.Encabezado.etiquetas;

    //*useState
      const [swRecarga, setSwRecarga] =  useState(false);
      const [swRecargaEncabezado, setSwRecargaEncabezado] =  useState(false); //usado para remasterizar esta página
      const [cargandoSpin, setCargandoSpin] = useState(false);

      const [abreSP, setAbreSP] = useState(false);
      const [abreVta,setAbreVta] = useState('');

      /* const [swCargaNotificaciones, setSwCargaNotificaciones] =  useState(false);
      const [ventanaAbierta, setVentanaAbierta] = useState(false);
      const [encabezadoVentana, setEncabezadoVentana] = useState("");
      const [opcionVentana, setOpcionVentana] = useState("");
      const [isdisabledConfig, setIsdisabledConfig] = useState(true); */

    //*useEffect
      useEffect(() => { //para saber le rol y en que página lo ubicamos
        //console.log("rolsStore: ", rolsStore);
        generaMenuxRolStore(rolsStore); //genera el menú correspondiente según el rol(es) del usuario
        //console.log("menuxRolStore: ", menuxRolStore);
      }, []);

      useEffect(()=> {  //usado para renderizar
        //console.log('renderizando Encabezado.........................');
        setSwRecargaEncabezado(!swRecargaEncabezado);
        recargaPaginaSSC_Not();
      },[swRecarga]); 

    //*funciones
      const recargaEncabezado = () => {
        //console.log('recargaContenido....');
        setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
      }

      const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() }

      const abreVentanaSlidingPanel = (vta:any) => {
        if (vta=='N') { setAbreVta('N') }
        if (vta=='P') { setAbreVta('P') }
        setAbreSP(true);
      }

      const botonCierraSlidingPanel = () => {
        setAbreSP(false);
        recargaEncabezado();       
      }

      //cierra la sesionabrePerfil
      const cierraSesion = () => {
        //para localStore
        localStorage.removeItem("usuario");
        sessionStorage.removeItem("usuario");
        localStorage.clear();
        sessionStorage.clear();
        //para reinicializar store's en su caso
        //setStepsDefault().catch(null); //ejemplo de AAIE
        //setTopicSelectDefault().catch(null);//ejemplo de AAIE
        //reinicializa
        const SERV_URL=process.env.REACT_APP_SERV_URL;
        const SERV_HOSTNAME=process.env.REACT_APP_SERV_HOSTNAME;
        window.location.hostname===SERV_HOSTNAME 
        ? window.location.replace(SERV_URL!)
        :  history.push("/");
      }

      const [show, setShow] = useState(false);
      const handleClose = () => setShow(false);

      /* const abrePerfil = () => {  
        alert("abre")  
        setShow(true);   //muestra modal
        handleClose11(); //cierra menu perfil, desconectar
      }; */
     
     
      const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
      const open = Boolean(anchorEl);

      const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose11 = () => {
        setAnchorEl(null);        
      };

      

    //*vista
    return (
      <>
       {/* barra de encabezado  & barra de Menú principal*/}
          <div id="perUser">

            {/* logos & notificaciones & perfil & cerrar sesión */}
              <Navbar collapseOnSelect variant="dark" className="fixed-top background-color-azul-marino " expand="lg" >
              
                {/* logo inegi/ssc & msj de dominio */}
                  <Navbar.Brand className="margin-left-1r">
                    <div className="display-flex">
                      <img src={LogoProyecto} alt="logo INEGI/SSC" id="imglogo" />
                      <span className={ APP_ENV?.toLowerCase().includes("training") ? "block" : "hide" } >
                        <img src={LineaT} /> {eti_Eti[0].text}
                      </span>
                      <span className={ APP_ENV?.toLowerCase().includes("productivodesarrollo") ? "block" : "hide" } >
                        <img src={LineaT} /> SITIO PRODUCTIVO DESARROLLO
                      </span>
                      <span className={ APP_ENV?.toLowerCase() === "local" ? "block" : "hide" } >
                        <span style={{ marginTop: "8px" }} className={  APP_ENV?.toLowerCase() === "local" ? "block" : "hide" } >
                            <img src={LineaT} id="imglogo1" /> <span id="texLogo">{eti_Eti[1].text}</span>
                        </span>
                      </span>
                    </div>
                  </Navbar.Brand>

                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                
                {/*notificaciones(campana) & perfil & nombre del usuario */}
                  <div id="perUser2">
                    <Navbar.Collapse className="justify-content-end"  >
                      <Nav >
                        <Nav.Link style={{paddingLeft:"0px"}} title="Notificaciones" className={props.notTotalStore!=0 ? "Notify" :  "opacityNav"} //si no tiene elementos, desactiva las notificaciones                   
                        >
                          <span  className="circuloNot circuloText cursorHand ng-binding" onClick={() => abreVentanaSlidingPanel('N')}>{props.notTotalStore} </span>
                          <FaBell size={30} onClick={() => abreVentanaSlidingPanel('N')}  title="Notificaciones" className="cursor"/>                         
                        </Nav.Link>
                        &nbsp;
                        <Nav.Link title="Perfil del Usuario" >
                          <div id="perUs">
                            <Button1
                              id="basic-button"
                              // aria-controls={open ? "basic-menu" : undefined}
                              // aria-expanded={open ? "true" : undefined}
                              onClick={() => abreVentanaSlidingPanel('P')}
                            >
                              <FaUserCircle size={35}  id="imgUser" /> <div className="blanco">{usuarioStore}</div>
                            </Button1>
                          </div>
                        </Nav.Link>
                      </Nav>
                    </Navbar.Collapse>
                  </div>   
                 <div>
                 
                 <ImExit size={30} color="white" title="Cerrar Sesión" onClick={cierraSesion} className="CerrarS"/>
                 </div>
              </Navbar>
            
            <br/><br/>

            {/* menu */}
              <GeneraMenu tipo={1} msj={""} />

          </div>

        {/* abre ventana SlidingPanel con Notificación o Perfil */}
          { (abreVta=='N' && abreSP) &&
              (<>
                  <SlidingPanel isOpen={abreSP} type='right' size={60} 
                    title='Notificaciones' 
                    closeClick={()=>botonCierraSlidingPanel()} >
                        <Notificaciones tokenStore={props.tokenStore}  />
                  </SlidingPanel>
              </>)
          }    
          { (abreVta=='P' && abreSP) &&
              (<>
                  <SlidingPanel isOpen={abreSP} type='right' size={50}
                    title='Perfil del usuario' 
                    closeClick={()=>botonCierraSlidingPanel()} >
                      <Perfil tokenStore={props.tokenStore} usuarioStore={usuarioStore}  rolsStore={rolsStore} />
                  </SlidingPanel>
              </>)
          }

        {/* ventana de carga con spin que se abre mientras lee el api */}
          { cargandoSpin? <CargandoSpin /> : null }
      </>
    );
  }

